var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"breadcrumbs"},[_c('router-link',{attrs:{"to":"/main"}},[_vm._v("Главная B2B")]),_vm._v(" - "+_vm._s(_vm.page.title)+"\n  ")],1),_vm._v(" "),_c('News'),_vm._v(" "),_c('div',{staticClass:"panel_title"},[_vm._v(_vm._s(_vm.page.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }